import React from 'react';
import { FontSizes } from '@itds/Theme';

const H1 = ({ children }) => {
  const styles = {
    fontFamily: 'Quicksand',
    fontSize: FontSizes.XLARGE,
    fontWeight: 500,
    marginBottom: 30
  };

  return <h1 style={styles}>{children}</h1>;
};

export default H1;
